import React from 'react';
import { Link } from 'react-router-dom';
import { 
  BookOpen, 
  Phone, 
  Mail, 
  MapPin, 
  Facebook, 
  Twitter, 
  Instagram, 
  Linkedin,
  Heart,
  Globe
} from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Free Study Material', path: '/study-material' },
    { name: 'Contact', path: '/contact' },
    { name: 'Register', path: '/register' },
    { name: 'Login', path: '/login' },
  ];

  const services = [
    'Home Tutoring',
    'Online Classes',
    'Exam Preparation',
    'Subject Specialization',
    'Personalized Learning',
  ];

  const contactInfo = [
    {
      icon: Phone,
      text: '+91 73860 78298',
      link: 'tel:+917386078298'
    },
    {
      icon: Mail,
      text: 'klm7778777@gmail.com',
      link: 'mailto:klm7778777@gmail.com'
    },
    {
      icon: Globe,
      text: 'klmhometuitions.website',
      link: 'https://klmhometuitions.website'
    },
    {
      icon: MapPin,
      text: 'Hyderabad, Telangana, India',
      link: '#'
    }
  ];

  const socialLinks = [
    { icon: Facebook, href: 'https://www.facebook.com/p/Klm-Hometuitions-61593906457029/', label: 'Facebook' },
    { icon: Twitter, href: '#', label: 'Twitter' },
    { icon: Instagram, href: 'https://www.instagram.com/klmhometuition/', label: 'Instagram' },
    { icon: Linkedin, href: '#', label: 'LinkedIn' },
  ];

  return (
    <footer className="bg-gray-900 text-white">
      {/* Main Footer Content */}
      <div className="max-w-5xl mx-auto px-4 py-6">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <div className="flex items-center space-x-2 mb-3">
              <BookOpen className="h-8 w-8 text-primary-400" />
              <span className="text-xl font-medium font-serif uppercase tracking-wider">KLM Home Tuitions</span>
            </div>

            <div className="flex space-x-4">
              {socialLinks.map((social, index) => {
                const Icon = social.icon;
                return (
                  <a
                    key={index}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-primary-600 transition-colors duration-200"
                    aria-label={social.label}
                  >
                    <Icon className="h-5 w-5" />
                  </a>
                );
              })}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-base font-serif font-normal uppercase tracking-wider mb-3">Quick Links</h3>
            <ul className="space-y-3">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <Link
                    to={link.path}
                    className="text-gray-300 hover:text-primary-400 transition-colors duration-200"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Tech Services */}
          <div>
            <h3 className="text-base font-serif font-normal uppercase tracking-wider mb-3">Tech Services</h3>
            <ul className="space-y-3">
              {[
                { name: 'Web Development', path: '/contact#tech-solutions' },
                { name: 'App Development', path: '/contact#tech-solutions' },
                { name: 'UI/UX Design', path: '/contact#tech-solutions' },
                { name: 'SEO Optimization', path: '/contact#tech-solutions' }
              ].map((service, index) => (
                <li key={index}>
                  <a
                    href={service.path}
                    className="text-gray-300 hover:text-primary-400 transition-colors duration-200"
                  >
                    {service.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>



          {/* Contact Info */}
          <div>
            <h3 className="text-base font-serif font-normal uppercase tracking-wider mb-3">Contact Info</h3>
            <div className="space-y-4">
              {contactInfo.map((contact, index) => {
                const Icon = contact.icon;
                return (
                  <a
                    key={index}
                    href={contact.link}
                    className="flex items-center space-x-3 text-gray-300 hover:text-primary-400 transition-colors duration-200"
                  >
                    <Icon className="h-5 w-5 flex-shrink-0" />
                    <span>{contact.text}</span>
                  </a>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="max-w-5xl mx-auto px-4 py-4">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-gray-400 text-sm mb-4 md:mb-0">
              © {currentYear} KLM HOME TUITIONS. All rights reserved.
            </div>
            <p className="text-gray-400 text-sm flex items-center justify-center md:justify-end gap-1">
              Made with <Heart className="h-4 w-4 text-red-500 fill-current" /> 
              <span>by KATKOJWAL KRISHNA M.SC</span>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 
